<ng-container *ngrxLet="routeData$ as routeData">
  <div
    class="cg-main-page-container"
    *ngrxLet="{
      isResourcePage: isResourcePage$,
      isLoading: isRouteGuardLoading$,
      isSiteDown: siteDownFlag$,
      pageLayout: pageLayout$,
      pageBg: pageBg$
    } as check"
  >
    <ng-container *ngIf="check.isSiteDown; else mainPage">
      <cigna-evernorth-header
        [firstName]="firstName$ | async"
        [lastName]="lastName$ | async"
        [userid]="userid$ | async"
        [profileLinks]="profileNav$ | async"
        [isImpersonator]="impersonator$ | async"
        [isNavigationDisabled]="true"
        [isAuthenticated]="true"
        [logoLink]="logoLink$ | async"
        [isLogoLinkInternal]="!check.isResourcePage"
        [isMessageCenterEnabled]="messageCenterEnabled$ | async"
        (logOut)="shellFacade.logOut($event)"
      ></cigna-evernorth-header>
      <main role="main">
        <cigna-evernorth-unavailable
          [shouldShowRefreshBtn]="false"
        ></cigna-evernorth-unavailable>
      </main>
    </ng-container>
    <ng-template #mainPage>
      <header role="banner">
        <cigna-password-change-banner-v2
          *ngIf="(shouldShowPwBanner$ | async) && !routeData.disableNavigation"
          [passwordExpiry]="passwordExpiry$ | async"
        ></cigna-password-change-banner-v2>

        <cigna-evernorth-header
          [firstName]="firstName$ | async"
          [lastName]="lastName$ | async"
          [userid]="userid$ | async"
          [profileLinks]="profileNav$ | async"
          [isImpersonator]="impersonator$ | async"
          [isNavigationDisabled]="routeData.disableNavigation"
          [isAuthenticated]="true"
          [logoLink]="logoLink$ | async"
          [isLogoLinkInternal]="!check.isResourcePage"
          [isMessageCenterEnabled]="messageCenterEnabled$ | async"
          (logOut)="shellFacade.logOut($event)"
        ></cigna-evernorth-header>

        <ng-container *ngIf="!routeData.disableNavigation && !check.isLoading">
          <cigna-primary-nav
            class="cg-hide-for-print"
            [links]="siteNav$ | async"
            [isImpersonator]="impersonator$ | async"
          ></cigna-primary-nav>
          <cigna-alerts-v2
            [alerts]="secureAlerts"
            [isTasksAlertsEnabled]="isTaskAlertsEnabled$ | async"
          ></cigna-alerts-v2>
          <cigna-alerts-tasks
            *ngIf="isTaskAlertsEnabled$ | async"
            [alerts]="userAlerts$ | async"
            [isImpersonator]="impersonator$ | async"
            (startReview)="onStartReview($event)"
          ></cigna-alerts-tasks>
        </ng-container>
      </header>

      <main
        role="main"
        [class.cg-padding-top-none]="
          (check.pageLayout === 'customFlush' ||
            check.pageLayout === 'customFlushTop') &&
          !check.isLoading
        "
        [class.cg-padding-bottom-none]="
          check.pageLayout === 'customFlush' && !check.isLoading
        "
        [class.page-bg-subtle]="check.pageBg === 'subtle' && !check.isLoading"
        [attr.data-layout]="check.pageLayout"
      >
        <div
          [class.cg-inner-page-wrapper]="
            check.pageLayout === 'default' || check.isLoading
          "
        >
          <ng-container *ngIf="check.isLoading">
            <div class="cg-inner-page-wrapper" style="min-height: 500px">
              <ng-leaf-loading-spinner
                label="Loading..."
                class="loader"
                size="large"
              ></ng-leaf-loading-spinner>
            </div>
          </ng-container>
          <router-outlet></router-outlet>
        </div>
      </main>
    </ng-template>
    <footer role="contentinfo" class="cg-hide-for-print">
      <cigna-evernorth-footer [isLoggedIn]="true"></cigna-evernorth-footer>
    </footer>
  </div>

  <aside *ngIf="isInBrowserPlatform">
    <cigna-timeout-popup></cigna-timeout-popup>
  </aside>

  <aside *ngIf="isDevMode">
    <cigna-dev-toggle class="cg-hide-for-print"></cigna-dev-toggle>
  </aside>
</ng-container>
